import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/app_shell';
import { AthletePage } from './pages/athlete_page';
import { HomePage } from './pages/home_page';
import { LeaderboardPage } from './pages/leaderboard_page';
import { NotFoundPage } from './pages/not_found_page';
import { PrivacyPolicyPage } from './pages/privacy_policy_page';
import { UploadDataRoute } from './pages/upload_data_route';
import { AdminResultsRoute } from './pages/admin_results_route';

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="athletes/:athleteId" element={<AthletePage />} />
        <Route path="leaderboard" element={<LeaderboardPage />} />
        <Route path="admin/upload-data" element={<UploadDataRoute />} />
        <Route path="admin/results" element={<AdminResultsRoute />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
